<!--zzjsbmztdxmbllc.vue  重症精神病门诊特定项目办理流程-->
<template>
  <div class="zzjsbmztdxmbllc-all-box">
    <div class="img-box">
      <img src="~@/assets/images/serviceGuide/zzjsbmztdxmbllc.png" width="100%" alt="">
    </div>
    <div class="text">
      医保物价办电话：0512-65795492
    </div>
  </div>
</template>

<script>
export default {
  name: 'Zzjsbmztdxmbllc',
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.zzjsbmztdxmbllc-all-box {
  background-color: #FFFFFF;
  padding: 10px;
}
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  background-color: #FFFFFF;
}
.text {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  padding: 40px;
}
</style>
